import Register from "./Register";
import Login from "./Login";
import Logout from "./Logout";
import ForgetPassword from "./ForgetPassword";
import ResetPassword from "./ResetPassword";

const Auth = {
    Register,
    Login,
    Logout,
    ForgetPassword,
    ResetPassword,
}
export default Auth;